/**
 * @generated SignedSource<<98616049733bdf1028c40b9de39af4af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StreamSettings_ToggleSchedulingMeetingAssistantMutation$variables = {
  streamId: string;
  value: boolean;
};
export type StreamSettings_ToggleSchedulingMeetingAssistantMutation$data = {
  readonly toggleSchedulingMeetingAssistantAutomation: {
    readonly stream: {
      readonly automationConfigurations: ReadonlyArray<{
        readonly automation: {
          readonly codeName: string;
        };
        readonly id: string;
        readonly isActive: boolean;
        readonly stream: {
          readonly hasAnyAutomationActive: boolean;
          readonly id: string;
        };
        readonly tasks: ReadonlyArray<{
          readonly __typename: string;
          readonly data?: {
            readonly addBanner: boolean;
            readonly allParticipants: boolean;
            readonly channelId: string;
            readonly channelName: string;
            readonly conversation: string;
            readonly conversationName: string;
            readonly emails?: ReadonlyArray<string>;
            readonly includeAiSummary: boolean;
            readonly isUser: boolean;
            readonly message: string;
            readonly notificationPath: string;
            readonly sendNotificationTo: string;
            readonly slackTeamId: string | null;
            readonly team: string;
            readonly teamName: string;
            readonly type: string;
            readonly userIds?: ReadonlyArray<string>;
            readonly zoomChannelId: string;
            readonly zoomChannelName: string;
          };
          readonly delta: number;
          readonly id: string;
        }>;
      }> | null;
      readonly id: string;
      readonly schedulingMeetingAssistantAutomationIsActive: boolean;
    };
  } | null;
};
export type StreamSettings_ToggleSchedulingMeetingAssistantMutation = {
  response: StreamSettings_ToggleSchedulingMeetingAssistantMutation$data;
  variables: StreamSettings_ToggleSchedulingMeetingAssistantMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "streamId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "value"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "streamId",
    "variableName": "streamId"
  },
  {
    "kind": "Variable",
    "name": "value",
    "variableName": "value"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "schedulingMeetingAssistantAutomationIsActive",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "codeName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStream",
  "kind": "LinkedField",
  "name": "stream",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAnyAutomationActive",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sendNotificationTo",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notificationPath",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allParticipants",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slackTeamId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "channelId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "channelName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "team",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "conversation",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "conversationName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUser",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomChannelId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomChannelName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "includeAiSummary",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "tasks",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "delta",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSaverReminder",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "addBanner",
              "storageKey": null
            },
            (v8/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "TimeSaverReminderAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSaverCancellation",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v8/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "TimeSaverCancellationAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmailReminder",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "userIds",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "EmailReminderAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SlackReminder",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v10/*: any*/),
            (v12/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "SlackReminderAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MSTeamsReminder",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v10/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "MSTeamsReminderAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ZoomReminder",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v10/*: any*/),
            (v20/*: any*/),
            (v21/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "ZoomReminderAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmailRecap",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emails",
              "storageKey": null
            },
            (v22/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "EmailRecapAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SlackRecap",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v10/*: any*/),
            (v12/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/),
            (v22/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "SlackRecapAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MSTeamsRecap",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v10/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v22/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "MSTeamsRecapAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ZoomRecap",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v10/*: any*/),
            (v20/*: any*/),
            (v21/*: any*/),
            (v22/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "ZoomRecapAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PromptNotification",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v10/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "PromptNotificationAutomationTask",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StreamSettings_ToggleSchedulingMeetingAssistantMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleSchedulingMeetingAssistantAutomation",
        "kind": "LinkedField",
        "name": "toggleSchedulingMeetingAssistantAutomation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AutomationConfigurationNode",
                "kind": "LinkedField",
                "name": "automationConfigurations",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AutomationNode",
                    "kind": "LinkedField",
                    "name": "automation",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StreamSettings_ToggleSchedulingMeetingAssistantMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleSchedulingMeetingAssistantAutomation",
        "kind": "LinkedField",
        "name": "toggleSchedulingMeetingAssistantAutomation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AutomationConfigurationNode",
                "kind": "LinkedField",
                "name": "automationConfigurations",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AutomationNode",
                    "kind": "LinkedField",
                    "name": "automation",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ef13f63e478a9700dc2e9141b2031042",
    "id": null,
    "metadata": {},
    "name": "StreamSettings_ToggleSchedulingMeetingAssistantMutation",
    "operationKind": "mutation",
    "text": "mutation StreamSettings_ToggleSchedulingMeetingAssistantMutation(\n  $streamId: ID!\n  $value: Boolean!\n) {\n  toggleSchedulingMeetingAssistantAutomation(streamId: $streamId, value: $value) {\n    stream {\n      id\n      schedulingMeetingAssistantAutomationIsActive\n      automationConfigurations {\n        id\n        isActive\n        automation {\n          codeName\n          id\n        }\n        stream {\n          id\n          hasAnyAutomationActive\n        }\n        tasks {\n          __typename\n          id\n          delta\n          ... on TimeSaverReminderAutomationTask {\n            data {\n              type\n              addBanner\n              sendNotificationTo\n            }\n          }\n          ... on TimeSaverCancellationAutomationTask {\n            data {\n              type\n              sendNotificationTo\n            }\n          }\n          ... on EmailReminderAutomationTask {\n            data {\n              notificationPath\n              message\n              allParticipants\n              userIds\n            }\n          }\n          ... on SlackReminderAutomationTask {\n            data {\n              notificationPath\n              message\n              slackTeamId\n              channelId\n              channelName\n            }\n          }\n          ... on MSTeamsReminderAutomationTask {\n            data {\n              notificationPath\n              message\n              team\n              teamName\n              conversation\n              conversationName\n              isUser\n            }\n          }\n          ... on ZoomReminderAutomationTask {\n            data {\n              notificationPath\n              message\n              zoomChannelId\n              zoomChannelName\n            }\n          }\n          ... on EmailRecapAutomationTask {\n            data {\n              notificationPath\n              message\n              allParticipants\n              emails\n              includeAiSummary\n            }\n          }\n          ... on SlackRecapAutomationTask {\n            data {\n              notificationPath\n              message\n              slackTeamId\n              channelId\n              channelName\n              includeAiSummary\n            }\n          }\n          ... on MSTeamsRecapAutomationTask {\n            data {\n              notificationPath\n              message\n              team\n              teamName\n              conversation\n              conversationName\n              isUser\n              includeAiSummary\n            }\n          }\n          ... on ZoomRecapAutomationTask {\n            data {\n              notificationPath\n              message\n              zoomChannelId\n              zoomChannelName\n              includeAiSummary\n            }\n          }\n          ... on PromptNotificationAutomationTask {\n            data {\n              message\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0566efbb968285e4cba19f1c5c5f887d";

export default node;
